export default "__VITE_ASSET__UJ6dtkTJ__"